module.exports = __webpack_public_path__ + "static/media/image-banner-mall-center.e21d2c60.png";